/**
 * Production build checks for MVP demo/offline flags (delta §8.3).
 * Logs to console when misconfigured; does not block rendering.
 */
export function collectMvpProductionEnvIssues(): string[] {
  if (process.env.NODE_ENV !== 'production') {
    return [];
  }
  const issues: string[] = [];
  if (process.env.REACT_APP_EXO_EXECUTION_SIGNALS_MOCK === 'true') {
    issues.push('REACT_APP_EXO_EXECUTION_SIGNALS_MOCK must not be true in production.');
  }
  if (process.env.REACT_APP_DRIVE_USE_DEDICATED_LOCAL_BRIDGE === 'true') {
    issues.push('REACT_APP_DRIVE_USE_DEDICATED_LOCAL_BRIDGE must not be true in production.');
  }
  if (process.env.REACT_APP_EXO_EXECUTION_SIGNALS_LIVE === 'false') {
    issues.push('REACT_APP_EXO_EXECUTION_SIGNALS_LIVE must not be false in production.');
  }
  return issues;
}

export function reportMvpProductionEnvIssues(): void {
  const issues = collectMvpProductionEnvIssues();
  if (issues.length > 0) {
    console.error('[Krysalis] Production configuration:', issues.join(' '));
  }
}
